var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNextAvailableTimeButton || _vm.forceShow)?_c('div',{staticClass:"next-available-time-button-wrapper"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }